export default __webpack_public_path__ + "static/illustration-content.url-365aeab38cc23a36eecf2391a641c237.svg";